{
    "onetoone": {
        "Hepsi": "All",
        "Baslik": "One to One",
        "Kullanici": "User",
        "Tarih": "Date",
        "Durum": "Status",
        "Yil": "Year",
        "Ay": "Month",
        "Gorus": "Opinion",
        "Not": "Note",
        "HedefRandevu": "Target Appointment",
        "YapilanRandevu": "Actual Appointment",
        "HedefReferans": "Target Reference",
        "YapilanReferans": "Actual Reference",
        "Urun": "Product",
        "Hedef": "Target",
        "Yapilan": "Actual",
        "Temizle": "Clear",
        "Arama": "Search",
        "Ara": "Search",
        "Kapat": "Close",
        "Kaydet": "Save",
        "KaydetKapat": "Save and Close",
        "Yenile": "Refresh",
        "YeniEkle": "Add New",
        "Olustur": "Create",
        "Seciniz": "Select",
        "Bekliyor": "Waiting",
        "GorusAldi": "Opinion Received",
        "Tamamlandi": "Completed",
        "Iptal": "Cancel",
        "EminMisiniz": "Are you sure?",
        "SilmeMesaj": "You cannot undo this!",
        "Sil": "Delete"
    }
}
